module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "工程师ID"
    },
    model: {
      value: (_vm.filters.masterId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "masterId", $$v)
      },
      expression: "filters.masterId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "等级"
    },
    model: {
      value: (_vm.filters.level),
      callback: function($$v) {
        _vm.$set(_vm.filters, "level", $$v)
      },
      expression: "filters.level"
    }
  }, _vm._l((_vm.level), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "phone", $$v)
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "店铺名称"
    },
    model: {
      value: (_vm.filters.storeName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "storeName", $$v)
      },
      expression: "filters.storeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-cascader', {
    attrs: {
      "clearable": "",
      "placeholder": "地区",
      "options": _vm.provinces,
      "props": _vm.props
    },
    on: {
      "active-item-change": _vm.select_ChangeEvent
    },
    model: {
      value: (_vm.filters.regionId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "regionId", $$v)
      },
      expression: "filters.regionId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getusers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出工程师余额EXCEL")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "border": "",
      "stripe": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "付款账号"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.logistics))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "营业时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.workTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "服务类型"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatServiceType")(props.row.serviceType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "备注"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.remark))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片详情"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryImage(props.row)
            }
          }
        }, [_vm._v("点击查看\n                                ")])], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "经营主体"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.storeInfo))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "技能标签"
          }
        }, [_c('span', [_vm._v(_vm._s(("" + (typeof props.row.skills=='undefined'?'':props.row.skillsDesc))))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8
          }
        }, [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "等级-积分"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatLevel")(props.row.level)) + "-" + _vm._s(props.row.score))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "面试方式"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("formatInterview")(props.row.interviewType)))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邀请码"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.recommendCode))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "详细地址"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.address))])])], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "masterId",
      "label": "ID",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storeName",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号码",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastLoginTime",
      "label": "是否关注",
      "width": "100",
      "formatter": _vm.formatLastLoginTime
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "等级",
      "width": "120",
      "formatter": _vm.formatLevel
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "joinTime",
      "label": "加入时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "regionAddress",
      "label": "地区",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money",
      "label": "余额",
      "width": "80",
      "formatter": _vm.formatMoney
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCount",
      "label": "订单量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small",
            "disabled": scope.row.orderCount == 0
          },
          on: {
            "click": function($event) {
              return _vm.goInstallOrder(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看:" + _vm._s(scope.row.orderCount) + "\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.accountType == 0) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editMoney(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改余额\n                ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.goMoneyLog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("余额日志")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#ff4949"
          },
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.rowCount,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看图片",
      "close-on-click-modal": false,
      "customClass": "customWidth"
    },
    model: {
      value: (_vm.queryImageVisible),
      callback: function($$v) {
        _vm.queryImageVisible = $$v
      },
      expression: "queryImageVisible"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.images,
      "label-width": "120px"
    }
  }, [(_vm.images.doorPic) ? _c('el-form-item', {
    attrs: {
      "label": "门头相片"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.images.doorPic
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.images.workPic) ? _c('el-form-item', {
    attrs: {
      "label": "工位相片"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.images.workPic
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.images.licensePic) ? _c('el-form-item', {
    attrs: {
      "label": "营业执照"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.images.licensePic
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.images.idCardPic) ? _c('el-form-item', {
    attrs: {
      "label": "法人身份证"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.images.idCardPic
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "手机号码"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "工程师登录账号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "phone", $$v)
      },
      expression: "addForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "店铺名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.storeName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "storeName", $$v)
      },
      expression: "addForm.storeName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "工程师等级"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.level),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "level", $$v)
      },
      expression: "addForm.level"
    }
  }, _vm._l((_vm.level), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "地区"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择省市县",
      "options": _vm.provinces,
      "props": _vm.props
    },
    on: {
      "active-item-change": _vm.select_ChangeEvent
    },
    model: {
      value: (_vm.regionId),
      callback: function($$v) {
        _vm.regionId = $$v
      },
      expression: "regionId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "为了精准派单,请输入详细地址",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "remark", $$v)
      },
      expression: "addForm.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "手机号码",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "工程师登录账号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "phone", $$v)
      },
      expression: "editForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "店铺名称",
      "prop": "storeName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.storeName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "storeName", $$v)
      },
      expression: "editForm.storeName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "工程师等级",
      "prop": "level"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.level),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "level", $$v)
      },
      expression: "editForm.level"
    }
  }, _vm._l((_vm.level), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "地区",
      "prop": "regionId"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "不选择则使用之前地区",
      "options": _vm.provinces,
      "props": _vm.props
    },
    on: {
      "active-item-change": _vm.select_ChangeEvent
    },
    model: {
      value: (_vm.regionId),
      callback: function($$v) {
        _vm.regionId = $$v
      },
      expression: "regionId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "详细地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "为了精准派单,请输入详细地址",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", $$v)
      },
      expression: "editForm.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "remark", $$v)
      },
      expression: "editForm.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改余额",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editMoneyFormVisible),
      callback: function($$v) {
        _vm.editMoneyFormVisible = $$v
      },
      expression: "editMoneyFormVisible"
    }
  }, [_c('el-form', {
    ref: "editMoneyForm",
    attrs: {
      "model": _vm.editMoneyForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "变动金额"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "例:增加3元,输入:3 减少3元,输入:-3",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editMoneyForm.changeMoney),
      callback: function($$v) {
        _vm.$set(_vm.editMoneyForm, "changeMoney", $$v)
      },
      expression: "editMoneyForm.changeMoney"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "require",
    attrs: {
      "label": "修改原因"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入修改原因",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editMoneyForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.editMoneyForm, "reason", $$v)
      },
      expression: "editMoneyForm.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editMoneyFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMoneySubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-702c04c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/masterUser.vue
// module id = 1089
// module chunks = 1